import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Classes from './styles.module.scss';

const MatColor = ({
  isSelected, kind, onSelect, paperId, postFix, colorRgb, name
}) => {
  const radioId = `MountRadioControl-${ paperId }-${ kind }`;
  const radioName = `MountRadioControl-${ paperId }-${ postFix }`;

  const ref = useRef(null);

  const onClick = (e) => {
    e.preventDefault();
    ref.current.click();
  };

  return (
    <div key={ kind }>
      <button
        type="button"
        aria-label={ name }
        className={
          classnames(Classes.matColorHolder, { [Classes.matColorSelected]: isSelected })
        }
        onClick={ onClick }
      >
        <div className={ Classes.matColor } style={ { backgroundColor: `rgb(${ colorRgb.join(',') })` } } />
      </button>
      <input
        className={ Classes.matColorInput }
        type="radio"
        value={ kind }
        checked={ isSelected }
        onChange={ onSelect }
        id={ radioId }
        name={ radioName }
        ref={ ref }
      />
    </div>
  );
};

MatColor.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  kind: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  paperId: PropTypes.string.isRequired,
  postFix: PropTypes.string.isRequired,
  colorRgb: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired
};

export default MatColor;
